import { render, staticRenderFns } from "./dataStatis.vue?vue&type=template&id=069d7746"
import script from "./dataStatis.vue?vue&type=script&lang=js"
export * from "./dataStatis.vue?vue&type=script&lang=js"
import style0 from "./dataStatis.vue?vue&type=style&index=0&id=069d7746&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports